import React from 'react';
import { Link } from 'react-router-dom';
import { Artwork } from '../../types/Artwork';
import { ArtworkImage } from '../common/ArtworkImage';

interface ImageCardProps {
    artwork: Artwork;
    /** The section this card is shown in — the artwork route nests under it. */
    sectionPath: string[];
}

// Gallery tile: a square, white-padded card that preserves the artwork's
// aspect ratio; on hover/focus a white overlay fades in with the title (the signature
// interaction). The whole card is a link to the viewing room, labelled by the title so
// screen readers announce it cleanly while the image keeps its descriptive alt for SEO.
export const ImageCard = ({ artwork, sectionPath }: ImageCardProps) => {
    const to = `/${[...sectionPath, artwork.slug].join('/')}`;

    return (
        <Link
            to={to}
            aria-label={artwork.title}
            className="group relative block aspect-square bg-canvas"
        >
            <ArtworkImage artwork={artwork} fit="contain" className="h-full w-full p-2" />
            <span
                aria-hidden
                className="hover-overlay group-hover:opacity-85 group-focus-within:opacity-85"
            >
                {artwork.title}
            </span>
        </Link>
    );
};
